var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.getters.user)?_c('button',{staticClass:"btn btn-outline-success my-2 my-sm-0",attrs:{"type":"button"},on:{"click":_vm.login}},[_c('span',{staticClass:"oi oi-account-login"}),_vm._v(" Login ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }